import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ThemeColorProvider } from './contexts/ThemeColorContext';
import App from './App';
import '@splidejs/react-splide/css/core';
import { UnitProvider } from './contexts/UnitContext';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './AppInsights';
import getMsalInstance from './helpers/getMsalInstance';
import { EventType, EventMessage, AccountInfo, PublicClientApplication } from '@azure/msal-browser';

const msalInstance: PublicClientApplication = getMsalInstance();

msalInstance.initialize().then(() => {
    if (!msalInstance.getActiveAccount()) {
        const accounts: AccountInfo[] = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }

    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && 'account' in event.payload && event.payload.account) {
            const account = event.payload.account as AccountInfo;
            msalInstance.setActiveAccount(account);
        }
    });

    const container = document.getElementById('root') as HTMLElement;
    const root = ReactDOM.createRoot(container);

    root.render(
        <Router
            future={{
                v7_relativeSplatPath: true,
            }}
        >
            <AppInsightsContext.Provider value={reactPlugin}>
                <ThemeColorProvider>
                    <ThemeProvider>
                        <UnitProvider>
                            <App pca={msalInstance} />
                        </UnitProvider>
                    </ThemeProvider>
                </ThemeColorProvider>
            </AppInsightsContext.Provider>
        </Router>
    );
});
